import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useSessionStore } from '@/store/session'
import { LoadingState } from '@/components/ui/Feedback'

/**
 * Guarda la ruta de destino y redirige a /login?redirect=...; tras
 * autenticar, el usuario vuelve exactamente a donde estaba. Esto es
 * usabilidad, no seguridad: el backend vuelve a exigir el token en
 * cada endpoint protegido.
 */
export function RequireAuth() {
  const status = useSessionStore((state) => state.status)
  const location = useLocation()

  if (status === 'checking') {
    return <LoadingState label="Verificando tu sesión…" />
  }

  if (status === 'anonymous') {
    const redirect = encodeURIComponent(location.pathname + location.search)
    return <Navigate to={`/login?redirect=${redirect}`} replace />
  }

  return <Outlet />
}
